/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamGridQueryResponse,
  GetApiV1ExamGridQueryParams,
  GetApiV1ExamGrid400,
  GetApiV1ExamGrid401,
  GetApiV1ExamGrid500,
} from "../../types/examEvaluationController/GetApiV1ExamGrid.ts";

function getGetApiV1ExamGridUrl() {
  const res = { method: "GET", url: `/api/v1/exam/grid` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de provas para exibição no grid principal de avaliação, com suporte a filtros por disciplina, empresa, título, status (ativo/inativo), tipo de prova e status de planejamento. **(Requer Authorization para autenticação)**
 * @summary Listar provas no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/grid}
 */
export async function getApiV1ExamGrid(
  params?: GetApiV1ExamGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamGridQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamGrid400 | GetApiV1ExamGrid401 | GetApiV1ExamGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamGridUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
